import { createPortal } from 'react-dom';

import classes from './Footer.module.scss';

const Footer = ({ children, isExpanded }) => {
  const classNames = [];
  isExpanded && classNames.push(classes.content);

  return createPortal(
    <footer className={classNames.join(' ')}>
      <div className={isExpanded ? classes.expanded : classes['not-expanded']}>{children}</div>
    </footer>,
    document.body
  );
};

export default Footer;
